import { vec2, vec3, vec4, glMatrix, mat2d, mat3, mat4, quat } from "gl-matrix";
export default {
    vec2: vec2,
    vec3: vec3,
    vec4: vec4,
    glMatrix: glMatrix,
    mat2d: mat2d,
    mat3: mat3,
    mat4: mat4,
    quat: quat
};



// WEBPACK FOOTER //
// ./src/GLM.ts